import { useAnalysisStore } from '@modules/analysis/store/analysisStore';
import { LoadingTypography } from '@modules/common/components/LoadingTypography';
import { useGetQuantifyReportStatus } from '@modules/quantify/hooks';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { Box, CircularProgress, Stack } from '@mui/material';

interface QuantifyReportStatusWidgetProps {
  height?: number;
}

export const QuantifyReportStatusWidget = ({
  height = 300,
}: QuantifyReportStatusWidgetProps) => {
  const message = useGetQuantifyReportStatus();
  const isLoading = useAnalysisStore(({ isLoading }) => isLoading);
  const isQueryInProgress = useQuantifyStore(
    ({ visual }) =>
      visual.isTableQueryInProgress || visual.isChartQueryInProgress,
  );

  return (
    <Stack
      sx={{
        borderRadius: 2,
        height,
      }}
      spacing={1}
      alignItems="center"
      justifyContent="center"
    >
      <LoadingTypography
        variant="body1"
        color="text.secondary"
        skeletonWidth={400}
        isLoading={isLoading}
        textAlign="center"
        whiteSpace="break-spaces"
        data-role="quantify-chart-status-message"
      >
        {message}
      </LoadingTypography>
      {isQueryInProgress ? (
        <Box data-role="table-loading-indicator">
          <CircularProgress />
        </Box>
      ) : null}
    </Stack>
  );
};
